import React from 'react'
import StaticHeader from './StaticHeader';
import StaticFooter from './StaticFooter';
import ScrollTrackingContentsTable from './ScrollTrackingContentsTable';
import { Helmet } from 'react-helmet';
import Layout from "../../../src/layout/index";

let data = [{
    id: ' Disclaimer ', title: " Disclaimer ", content: [` This Website may
contain general information relating to various medical conditions and their
treatment. Such information is provided for informational purposes and for your
general interest only. Such information is not intended to be a substitute for
medical advice, diagnosis or treatment provided by a doctor or other qualified
healthcare professional. You should not use the information contained herein
for diagnosing or treating a health condition, problem or disease. Please
consult with your doctor or medical healthcare professional to see if any
information discussed at this Website is appropriate for you.` ]
},



{
    id: 'Rules and Use ', title: " Rules and Use ", content: [` If, and only if, you
agree to, and are in full compliance with, these Terms and Conditions of Use,
Doctall authorizes you to view and access a single copy of the publicly
available pages on the Website solely for your personal use. In addition, the
Website and the Content (as defined in Section III below) are made available
for the limited purpose of allowing you and/or your medical provider to use
Doctall Diagnostics Market place ordering and other services. Any other use,
duplication, distribution or other exploitation of the Website, the Content or
any portion thereof by any user is strictly prohibited. Without limiting the
foregoing, in no event may any user directly or indirectly: `, ` (a)
Republish, post, upload, frame, retransmit, redistribute, modify, remove any
intellectual property or similar notices or otherwise reproduce the Website or
any Content in any format to anyone in any way (other than the download to your
personal computer that is inherent in viewing a web page);



  `, `



 



(b) Access, attempt to access, or obtain any information
regarding other users (including, without limitation, any other users' tests
ordered or test results or any other personally identifiable information
related to another user);



 `, `(c) Allow anyone else to use or
access your name, account or password, if any;



 `, `(d) Use any robot, spider or other
data mining or other automatic device, program, or similar process or means to
access, acquire, copy or monitor the Website, another user, the Content or any
portion thereof, or in any way circumvent the navigational structure or
presentation of the Website or any Content;



 `, `(e) Breach or attempt to breach the
security or authentication measures on the Website or any network or database
connected to the Website;



 `, `(f) Collect any information related
to any Website users or other Content from the Website for the benefit of any
other entity or person or share this information with any other person or
entity;



 `, `



(g) Decompile, reverse engineer, disassemble or otherwise
reduce any software code for the Website to a human-readable form;



 



 `, `



 (h) Make any
automated high-volume or other use of the Website for re-mailing, spamming or
other purposes;



 `, `



(i) Use the Website or the Content in violation of any
applicable law, rule or regulation;



 `, `



(J) Use the Website for any purpose other than to utilize
the intended test ordering services offer through the Website;



 `, `



(k) Submit any data, content or other material that contains
a virus or other harmful component, or otherwise tampers with, impairs or
damages the Website, the Content or any connected network or database, or
otherwise interferes with any person or entity's use or enjoyment of the
Website;



 `, `



(l) Submit any data (including, without limitation credit
card and other payment data), content or other material in violation of any
applicable law or regulation, that violates or infringes upon the patent,
trademark, copyright, trade secret, privacy, publicity or other rights of any
third party;



 `, `



(m) Submit any data (including, without limitation credit
card and other payment data), content or other material that is false,
misleading, deceptive, defamatory, obscene, indecent, threatening, abusive,
offensive, harassing, or hateful; or



 `, `



(n) Pretend to be another person or entity or misrepresent
your identity, sponsorship, or affiliation with any such third party, including
using a third party's username, password, personally identifiable or other
account information.



 `, ` You must maintain the
confidentiality of your account and other information and to promptly notify us
if you become aware of any third party use of your account or other information
relating to the Website or the Content. You are responsible for all acts,
omissions, statements and other uses of your account and other information on
the Website.



 `, ` 



We cannot and do not assure that other users are complying,
or will continue to comply, with the provisions of these Terms and Conditions
of Use, and, as between you and Doctall, you assume all risk of harm or injury
resulting from any such lack of compliance.`,]
},



{
    id: 'Disclaimers-of-Liability-and-Warranties ', title: "Disclaimers of Liability and Warranties", content: [` By using this
Website, you hereby agree not to rely on any of the information contained
herein. Doctall will use reasonable efforts to include accurate and up-to-date
information on this Website, but DOCTALL MAKES NO WARRANTIES OR REPRESENTATION
OF ANY KIND REGARDING THE USE OF THIS WEBSITE OR AS TO ITS ACCURACY, CURRENCY,
RELIABILITY OR COMPLETENESS. Doctall reserves the right to make changes or
improvements to this Website at any time.



   `, ` 



Your access to and use of this website and the content hereof is at your own risk. This website and all the materials, information and services in this website, including, without limitation, text, graphics, and links (collectively, the "Content"), are provided "As-is" and without warranties of any kind, either expressed or implied. To the fullest extent permissible under applicable law, doctall disclaims all warranties, express or implied, including, but not limited to, warranties of merchantability, fitness for a particular purpose, accuracy, non-infringement, freedom from computer virus and warranties arising from course of dealing or course of performance.



 



 `,]
},
{
    id: ' Privacy- Statement- and- Policy', title: " Privacy Statement and Policy", content: [` Doctall respects your privacy. Please
see our Privacy Statement and Policy that explains your rights and
responsibilities with respect to information that is disclosed on or to this
Website. To the extent there is an inconsistency between these Terms and
Conditions of Use and the Doctall Privacy Statement and Policy, these Terms and
Conditions of Use shall govern.`,]
},



{
    id: ' Submission of-Ideas', title: " Submission of Ideas  ", content: [
        ` Doctall appreciates hearing from its customers and welcomes your
comments regarding this Website and/or Doctall products or services. However,
it is Doctall policy not to accept unsolicited ideas about new products,
advertising or marketing concepts or improvements. Doctall employs a staff and
consultants that may be working on ideas that are the same or similar to yours.
Doctall policy is to avoid confusion about our ownership of new concepts. If
you send us a message about a proposed idea, your message will be treated as
non-proprietary and non-confidential and becomes property of Doctall. Doctall
shall be free to use the content of any such communication, including any
ideas, inventions, concepts, techniques or know-how disclosed therein, for any
purpose whatsoever, including developing, manufacturing and/or marketing goods
or services, at our sole discretion, without compensation to you.`, ` 



You agree that you will not upload or transmit to this
Website any communications or content that infringe or violate any rights of
any party. In addition, you agree that you will not send or transmit to Doctall
by email, (including through the "Contact Us" link) any communication
or content that infringes or violates any rights of any party.



 `,]
}, {
    id: 'Links to Other Websites ', title: "Links to Other Websites ", content: [
        ` This Website may provide links or references to websites maintained by
third parties over whom Doctall has no control. Such links or references are
provided as a convenience to the users of this Website. Similarly, this Website
may be accessed from third party links over which Doctall has no control.
Doctall has no responsibility for and makes no representations or warranties of
any kind for the content of other websites linked to this Website, or for any
products or services mentioned or offered on such websites. Doctall shall not
be liable for any damages or injury arising from that content. You access such
other websites solely at your own risk. Inclusion of any third-party link does
not constitute an endorsement or recommendation by Doctall.`,]
},



{
    id: ' Applicable-Law  ', title: " Applicable Law ", content: [` This Website and the Content are intended to
comply with globally acceptable  laws and
regulations, and the information pertaining to Doctall products and services is
intended for use by residents of Nigeria and beyond. Doctall makes no
representation or warranty that the Content is appropriate or available for use
in other countries, and access to it from countries where its content is
illegal and prohibited. Those who choose to access this Website from other
countries do so on their own initiative and are solely responsible for
compliance with applicable local laws. Any offer for any product or service
made on this Website is void where prohibited`,]
},



{
    id: ' Copyright -and–Use- of- this- Website  ', title: " Copyright and Use of this Website   ", content: [
        ` All Content (including, without limitation, Website design, text,
graphics, icons and the selection and arrangement thereof) of this Website is
the property of Doctall, or used under license by Doctall, and is subject to
copyright protection. Doctall does not waive any of its proprietary rights to
such content.`, ` Doctall authorizes you
to display and electronically copy, download and print hard copy, for
non-commercial use only, documents or pages published by Doctall on this
Website, provided that any copy of these documents or pages which you make
shall retain all copyright or proprietary notices and any disclaimers contained
herein. Any other use of materials on the Website, including but not limited to
the modification, reproduction, distribution, republication, display or
transmission of the content of this Website, without prior written permission
of Doctall, is prohibited. The availability of the Contents through this
Website shall under no circumstance constitute a transfer of any copyrights,
trademarks or other intellectual property rights of Doctall to any Website user
or any third party. This Website and the Content are protected by copyright
laws, both as individual works and as a compilation. You may not delete any
copyright or similar notice from any content you obtain from this Website. All
Content Copyright © ${new Date().getFullYear()} – Doctall, all rights reserved. `, ` 



If you violate any of these Terms and Conditions of Use,
your permission to use the Content automatically terminates and you must
immediately destroy any copies you have made of any portion of the Content.



 `,]
},



{
    id: ' Trademarks ', title: " Trademarks ", content: [` All logos,
trademarks, service marks and trade dress (hereinafter collectively referred to
as "Trademarks") displayed on this Website, whether or not appearing
in large print or with or without the trademark symbol, are registered and
unregistered Trademarks of Doctall, or of third parties. Use of the Trademarks
displayed on this Website, or any Content, except as provided herein, is
strictly prohibited. Nothing contained in this Website should be construed as
granting, by implication, estoppel, or otherwise, any license or right to use
any Trademark displayed on this Website without the written permission of
Doctall or such third party that may own the Trademarks displayed at this
Website. Furthermore, please be advised that Doctall actively and aggressively
enforces its intellectual property rights to the fullest extent of the law.`,]
},



{
    id: ' Indemnification', title: " Indemnification ", content: [` You agree to
indemnify, defend, and hold harmless Doctall, its managers, members, employees,
partners, licensors and suppliers from and against all losses, expenses,
damages and costs, including reasonable attorneys' fees and court costs,
resulting from any violation of these Terms and Conditions of Use (including,
but not limited to, negligent or wrongful conduct) by you. Doctall reserves the
right, at its own expense, to assume the exclusive defence and control of any
matter otherwise subject to indemnification by you, in which event you will
cooperate with Doctall in asserting any available defences.


 `,]
},



{
    id: ' Termination-of-Your-Use-of-the-Website ', title: " Termination of Your Use of the Website ", content: [
        ` Doctall may terminate your use of the Website at any time and without
notice to you if, in its sole judgment, you breach any term or condition of
these Terms and Conditions of Use. Upon termination, you must destroy all
materials obtained from this Website.



 



 



 `,]
},







{
    id: ' Governing-Law ', title: " Governing Law  ", content: [
        ` These Terms and Conditions of Use and your use of the Website or the
Content shall be governed by the laws of Nigeria, without regard to its
conflict of laws provisions. Any legal action or proceeding relating to this
Website shall be brought exclusively in a federal or state court of competent
jurisdiction in Nigeria.



 



 



 `,]
},



{
    id: ' Entire-Agreement', title: " Entire Agreement", content: [` If any provision of
these Terms and Conditions of Use is unlawful, void or unenforceable, the
remaining provisions of these Terms and Conditions of Use will remain in place.
These Terms and Conditions of Use are the entire agreement between you and
Doctall regarding all aspects of your use of this Website and/or the Content. `]
}]



function TermsAndConditions() {
    return (
        <>
         <Layout>
        <Helmet>
            <title>diagnostics.doctall.com | Terms and Conditions
</title>
<meta 
            name='description' 
            content='By accessing our website, you are agreeing to be bound by these terms of service, and agree that you are responsible for compliance with any applicable local laws. Read more on this page'
            />
        </Helmet>
            {/* <StaticHeader /> */}
            <div className='service-container'>
                <div className='service-banner'>
                    <div className='title-align'>Terms & Conditions </div>
                </div>

            </div>
            <div style={{display : 'flex',justifyContent:"center",width:"100%"}}>
            <ScrollTrackingContentsTable data={data} />

            </div>
            {/* <StaticFooter /> */}
            </Layout>
        </>

    )
}

export default TermsAndConditions
